module.exports = __webpack_public_path__ + "static/media/fachada5.43b836fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Fachada/fachada5.jpg
// module id = 327
// module chunks = 0